module.exports = __webpack_public_path__ + "img/face_the_facts_logo.892a8e21.png";